module.exports = __webpack_public_path__ + "static/media/icon-double-chevon-left.757233a9.svg";